module.exports = __webpack_public_path__ + "static/img/ic_Incident.4aa5271b.png";